import { useParams } from 'react-router'
import { track } from '../../../sharedLegacy/utils/analytics'
import { useTray } from '../../../firebase/hooks/useTray'

function useTrayTracking() {
  const { live_id: liveId } = useParams<{ live_id: string }>()
  const { cards, getCard, getCardIndex } = useTray()

  function closed(isTrayOpen: boolean) {
    if (isTrayOpen) {
      track('Webinar tray closed ', {
        product: 'WebinarRoom',
        liveId,
      })
    } else {
      track('Webinar tray opened', {
        product: 'WebinarRoom',
        liveId,
      })
    }
  }

  function created(newCardType: string, previousCardId: string | undefined) {
    const newCardIndex = previousCardId
      ? (getCardIndex(previousCardId) ?? 0) + 1
      : 0

    track('Tray card created', {
      product: 'WebinarRoom',
      cardType: newCardType,
      liveId,
      cardIndex: newCardIndex,
      cardCount: cards?.length ?? 0,
    })
  }

  function activated(cardId: string) {
    if (!cards) return

    const cardIndex = getCardIndex(cardId)
    if (!cardIndex) return

    const card = getCard(cardId)
    if (!card) return

    track('Tray card activated', {
      product: 'WebinarRoom',
      cardType: card.type,
      liveId,
      cardIndex,
      cardCount: cards.length,
    })
  }

  function sorted() {
    if (!cards) return

    track('Tray card sorted', {
      product: 'WebinarRoom',
      liveId,
      cardCount: cards.length,
    })
  }

  function edited(cardId: string) {
    if (!cards) return

    const cardIndex = getCardIndex(cardId)
    if (!cardIndex) return
    const card = getCard(cardId)
    if (!card) return

    track('Submitted tray card edit', {
      product: 'WebinarRoom',
      cardType: card.type,
      liveId,
      cardIndex,
      cardCount: cards.length,
    })
  }

  function startedEdit(cardId: string) {
    if (!cards) return
    const cardIndex = getCardIndex(cardId)
    if (!cardIndex) return
    const card = getCard(cardId)
    if (!card) return

    track('Started tray card edit', {
      product: 'WebinarRoom',
      cardType: card.type,
      liveId,
      cardIndex,
      cardCount: cards.length,
    })
  }

  function deleted(cardId: string) {
    const card = getCard(cardId)
    if (!card) return

    track('Deleted tray card', {
      product: 'WebinarRoom',
      cardType: card.type,
      liveId,
    })
  }

  return {
    closed,
    created,
    activated,
    sorted,
    startedEdit,
    edited,
    deleted,
  }
}

export default useTrayTracking
